import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "appointment_call_time" } },
    [
      _c(
        "BannerInfo",
        {
          attrs: {
            "data-qa": "appointment_call_time_alert",
            "inner-atom-indent": 0,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "text-body-2 text--text",
              attrs: { "data-qa": "appointment_call_time_warning_text" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "Для подтверждения записи вам позвонит администратор",
                      _vm.options
                    )
                  ) +
                  "\n      "
              ),
              _c("span", { staticClass: "text-no-wrap font-weight-medium" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.selectedDate) + " в\n        "
                ),
                _c(
                  "span",
                  {
                    staticClass: "primary--text cursor-pointer",
                    attrs: { id: "timeSelectActivator" },
                  },
                  [_vm._v(_vm._s(_vm.selectedTimeRange))]
                ),
              ]),
              _vm._v(
                ".\n      " +
                  _vm._s(
                    _vm.$t("Сейчас в клинике нерабочее время.", _vm.options)
                  ) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "MenuBottomSheet",
        {
          attrs: {
            activator: "#timeSelectActivator",
            "data-qa": "appointment_call_time_bottom_sheet",
          },
          model: {
            value: _vm.isVisibleBottomSheet,
            callback: function ($$v) {
              _vm.isVisibleBottomSheet = $$v
            },
            expression: "isVisibleBottomSheet",
          },
        },
        [
          _c(
            VList,
            {
              staticClass: "overflow-y-auto",
              attrs: {
                "max-height": _vm.isMobile ? 392 : 240,
                "min-width": _vm.isMobile ? 0 : 320,
              },
            },
            _vm._l(_vm.availableAppointmentCallTimes, function (time, index) {
              return _c(
                VListItem,
                {
                  key: index,
                  attrs: {
                    color: "primary",
                    "input-value":
                      time.value === _vm.selectedAppointmentCallTime,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.clickListItem(time.value)
                    },
                  },
                },
                [
                  _c(
                    VListItemContent,
                    { staticClass: "text-body-1 text--text" },
                    [_vm._v("\n          " + _vm._s(time.text) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c(
                        VListItemIcon,
                        [
                          _c(VIcon, [
                            _vm._v(
                              "\n            ui-icon-arrow-right\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }